/**
 * Side cart discount code: apply and remove discounts, then refresh drawer HTML.
 * Standalone script; use event delegation so it works after drawer content is replaced.
 */
(function() {
  'use strict';

  var activeFetch = null;

  function getRootUrl() {
    if (typeof window.theme !== 'undefined' && window.theme.localeRootUrl !== undefined) {
      return window.theme.localeRootUrl;
    }
    if (typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '';
  }

  function buildRootPath(pathname) {
    var root = getRootUrl() || '';
    var path = pathname || '';
    if (path.charAt(0) !== '/') {
      path = '/' + path;
    }

    if (!root) return path;
    if (root.charAt(root.length - 1) === '/') {
      root = root.slice(0, -1);
    }

    return root + path;
  }

  function getExistingDiscountCodes(container) {
    var pills = container ? container.querySelectorAll('.cart-discount__pill') : [];
    var codes = [];
    for (var i = 0; i < pills.length; i++) {
      var code = pills[i].getAttribute('data-discount-code');
      if (code) codes.push(code);
    }
    return codes;
  }

  function hideErrors(container) {
    if (!container) return;
    var err = container.querySelector('[data-cart-discount-error]');
    var errCode = container.querySelector('[data-cart-discount-error-code]');
    var errShip = container.querySelector('[data-cart-discount-error-shipping]');
    if (err) err.classList.add('hidden');
    if (errCode) errCode.classList.add('hidden');
    if (errShip) errShip.classList.add('hidden');
  }

  function showDiscountCodeError(container) {
    if (!container) return;
    var err = container.querySelector('[data-cart-discount-error]');
    var errCode = container.querySelector('[data-cart-discount-error-code]');
    if (err) err.classList.remove('hidden');
    if (errCode) errCode.classList.remove('hidden');
  }

  function showShippingDiscountError(container) {
    if (!container) return;
    var err = container.querySelector('[data-cart-discount-error]');
    var errShip = container.querySelector('[data-cart-discount-error-shipping]');
    if (err) err.classList.remove('hidden');
    if (errShip) errShip.classList.remove('hidden');
  }

  function codeMatchesCandidate(rawTitle, valueUpper) {
    if (!rawTitle) return false;
    var titleUpper = String(rawTitle).toUpperCase();
    if (titleUpper === valueUpper) return true;

    // Some third-party discount apps concatenate codes with custom delimiters.
    var parts = titleUpper.split('^^^');
    return parts.some(function(part) {
      return part.trim() === valueUpper;
    });
  }

  function replaceDrawerContent(html) {
    var drawer = document.getElementById('sidebar-cart');
    if (!drawer) return;

    var temp = document.createElement('div');
    temp.innerHTML = html;

    var newCart = temp.querySelector('.Cart');
    var currentCart = drawer.querySelector('.Cart');
    if (newCart && currentCart && currentCart.parentNode) {
      currentCart.parentNode.replaceChild(newCart, currentCart);
    }

    var newDrawerRoot = temp.querySelector('#sidebar-cart');
    if (newDrawerRoot) {
      var newSettings = newDrawerRoot.getAttribute('data-section-settings');
      var newCount = newDrawerRoot.getAttribute('data-item-count');
      if (newSettings) drawer.setAttribute('data-section-settings', newSettings);
      if (newCount !== null && newCount !== undefined) drawer.setAttribute('data-item-count', newCount);
    }

    var settingsEl = temp.querySelector('[data-section-settings]');
    if (settingsEl && settingsEl.getAttribute('data-section-settings')) {
      try {
        var settings = JSON.parse(settingsEl.getAttribute('data-section-settings'));
        var itemCount = settings.itemCount != null ? settings.itemCount : 0;
        drawer.setAttribute('data-item-count', itemCount);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: itemCount } }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (e) {}
    }
  }

  function refreshDrawer() {
    var url = buildRootPath('/cart?view=drawer&timestamp=' + Date.now());
    return fetch(url, { credentials: 'same-origin', method: 'GET' })
      .then(function(res) { return res.text(); })
      .then(function(html) {
        replaceDrawerContent(html);
      });
  }

  function applyDiscount(event) {
    event.preventDefault();
    event.stopPropagation();

    var wrapperEl = event.target.getAttribute && event.target.getAttribute('data-cart-discount-form') !== null
      ? event.target
      : (event.target.closest && event.target.closest('[data-cart-discount-form]'));
    if (!wrapperEl) return;

    var drawer = document.getElementById('sidebar-cart');
    var wrapper = drawer ? drawer.querySelector('[data-cart-discount-wrapper]') : null;
    var input = wrapperEl.querySelector('[data-cart-discount-input]');
    if (!input) return;

    var value = (input.value || '').trim();
    if (!value) return;

    var existing = getExistingDiscountCodes(wrapper || drawer);
    var valueUpper = value.toUpperCase();
    var alreadyApplied = existing.some(function(c) { return (c || '').toUpperCase() === valueUpper; });
    if (alreadyApplied) return;

    if (activeFetch) activeFetch.abort();
    var controller = new AbortController();
    activeFetch = controller;

    hideErrors(wrapper || drawer);

    var applyBtn = wrapperEl.querySelector('[data-cart-discount-apply]');
    setApplyButtonLoading(applyBtn, true);

    var newCodes = existing.concat([value]);
    var body = JSON.stringify({ discount: newCodes.join(',') });

    fetch(buildRootPath('/cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body,
      signal: controller.signal
    })
      .then(function(res) {
        if (!res.ok) {
          throw new Error('cart_update_failed');
        }
        return res.json();
      })
      .then(function(data) {
        activeFetch = null;
        setApplyButtonLoading(applyBtn, false);

        var discountCodes = data.discount_codes || [];
        var valueUpper = value.toUpperCase();
        var applied = discountCodes.find(function(d) {
          var code = (d && d.code) ? String(d.code) : '';
          return code.toUpperCase() === valueUpper;
        });

        // Invalid codes may not appear in discount_codes at all; treat that as an error.
        if (!applied) {
          input.value = '';
          showDiscountCodeError(wrapper || drawer);
          return;
        }

        var applicable = applied.applicable === true || applied.applicable === 'true';

        if (!applicable) {
          input.value = '';
          showDiscountCodeError(wrapper || drawer);
          return;
        }

        // Only show "shipping only" error when code is applicable but not allocated on cart or lines.
        var cartLevelDiscounts = data.cart_level_discount_applications || [];
        var hasCartLevelDiscount = cartLevelDiscounts.some(function(discount) {
          var title = '';
          if (discount.discount_application && discount.discount_application.title) {
            title = discount.discount_application.title;
          } else if (discount.title) {
            title = discount.title;
          }
          return codeMatchesCandidate(title, valueUpper);
        });

        var items = data.items || [];
        var hasLineLevelDiscount = items.some(function(item) {
          var allocations = item.line_level_discount_allocations || [];
          return allocations.some(function(allocation) {
            var title = allocation && allocation.discount_application ? allocation.discount_application.title : '';
            return codeMatchesCandidate(title, valueUpper);
          });
        });

        if (!hasCartLevelDiscount && !hasLineLevelDiscount) {
          input.value = '';
          showShippingDiscountError(wrapper || drawer);
          return;
        }

        // Success: refresh drawer so UI shows applied discount and updated total
        return refreshDrawer();
      })
      .catch(function(err) {
        if (err && err.name === 'AbortError') return;
        activeFetch = null;
        setApplyButtonLoading(applyBtn, false);
        showDiscountCodeError(wrapper || drawer);
      });
  }

  function setApplyButtonLoading(btn, loading) {
    if (!btn) return;
    var textEl = btn.querySelector('[data-cart-discount-button-text]');
    var spinnerEl = btn.querySelector('[data-cart-discount-button-spinner]');
    if (loading) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      if (textEl) textEl.classList.add('hidden');
      if (spinnerEl) spinnerEl.classList.remove('hidden');
    } else {
      btn.disabled = false;
      btn.setAttribute('aria-busy', 'false');
      if (textEl) textEl.classList.remove('hidden');
      if (spinnerEl) spinnerEl.classList.add('hidden');
    }
  }

  function removeDiscount(event) {
    var target = event.target;
    var pill = target.closest && target.closest('.cart-discount__pill');
    if (!pill || !target.closest('[data-cart-discount-remove]') && !target.closest('.cart-discount-remove')) return;

    event.preventDefault();
    event.stopPropagation();

    var code = pill.getAttribute('data-discount-code');
    if (!code) return;

    var drawer = document.getElementById('sidebar-cart');
    var wrapper = drawer ? drawer.querySelector('[data-cart-discount-wrapper]') : null;
    var existing = getExistingDiscountCodes(wrapper || drawer);
    var idx = existing.indexOf(code);
    if (idx === -1) return;

    existing.splice(idx, 1);

    if (activeFetch) activeFetch.abort();
    var controller = new AbortController();
    activeFetch = controller;

    var body = JSON.stringify({ discount: existing.join(',') });

    fetch(buildRootPath('/cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body,
      signal: controller.signal
    })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        activeFetch = null;
        return refreshDrawer();
      })
      .catch(function(err) {
        if (err && err.name === 'AbortError') return;
        activeFetch = null;
      });
  }

  function init() {
    var drawer = document.getElementById('sidebar-cart');
    if (!drawer) return;

    drawer.removeEventListener('submit', onSubmit, true);
    drawer.removeEventListener('click', onClick, true);
    drawer.removeEventListener('keydown', onKeydown, true);

    drawer.addEventListener('submit', onSubmit, true);
    drawer.addEventListener('click', onClick, true);
    drawer.addEventListener('keydown', onKeydown, true);
  }

  function onSubmit(e) {
    if (e.target && e.target.getAttribute('data-cart-discount-form') !== null) {
      applyDiscount(e);
    }
  }

  function onClick(e) {
    if (e.target && (e.target.closest('[data-cart-discount-remove]') || e.target.closest('.cart-discount-remove'))) {
      removeDiscount(e);
    } else if (e.target && (e.target.closest('[data-cart-discount-apply]') || e.target.closest('.cart-discount-apply'))) {
      applyDiscount(e);
    }
  }

  function onKeydown(e) {
    if (e.key === 'Enter' && e.target && e.target.getAttribute('data-cart-discount-input') !== null) {
      e.preventDefault();
      var wrapperEl = e.target.closest && e.target.closest('[data-cart-discount-form]');
      if (wrapperEl) {
        var btn = wrapperEl.querySelector('[data-cart-discount-apply]');
        if (btn) btn.click();
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
